import { formatDistance } from 'date-fns'

import {
  Button,
  Flex,
  Label,
  Link,
  Paragraph,
  Text,
  WarningIcon,
} from '@buffer-mono/popcorn'

import { LINKEDIN_CAPABILITIES_HELP_CENTER_URL } from './config'
import commonStyles from '../../GeneralSettings.module.css'

const CHECK_CAPABILITIES_LABEL = 'Check for LinkedIn skills'

type CheckCapabilitiesCTAProps = {
  isChannelLocked: boolean
  isChecking: boolean
  lastCheckedAt: string | null
  errorMessage?: string
  onCheck: () => void
}

const CheckCapabilitiesCTA = ({
  isChannelLocked,
  isChecking,
  lastCheckedAt,
  errorMessage,
  onCheck,
}: CheckCapabilitiesCTAProps): React.JSX.Element => (
  <Flex direction="column" gap="sm" className={commonStyles.fullWidth}>
    <Flex
      justify="between"
      align="center"
      className={commonStyles.fullWidth}
      gap="xl"
    >
      <Flex direction="column">
        <Label>{CHECK_CAPABILITIES_LABEL}</Label>
        <Paragraph className={commonStyles.settingsParagraph}>
          {lastCheckedAt ? (
            <>
              Last checked{' '}
              {formatDistance(new Date(lastCheckedAt), new Date(), {
                addSuffix: true,
              })}
              .{' '}
            </>
          ) : (
            <>Capabilities are earned through your Buffer activity. </>
          )}
          <Link
            color="inherit"
            external
            href={LINKEDIN_CAPABILITIES_HELP_CENTER_URL}
          >
            Learn how to achieve them
          </Link>
        </Paragraph>
      </Flex>
      <Flex className={commonStyles.actionsWrapper}>
        <Button
          className={commonStyles.actionButton}
          size="large"
          variant="secondary"
          disabled={isChannelLocked}
          loading={isChecking}
          onClick={onCheck}
        >
          {CHECK_CAPABILITIES_LABEL}
        </Button>
      </Flex>
    </Flex>
    {isChannelLocked ? (
      <Text color="warning" icon={<WarningIcon size="small" color="warning" />}>
        You can&apos;t achieve new capabilities while your channel is locked.
      </Text>
    ) : null}
    {errorMessage ? (
      <Text role="alert" color="critical">
        {errorMessage}
      </Text>
    ) : null}
  </Flex>
)

export { CheckCapabilitiesCTA }
